import { ObservableFromFetch } from "../ObservableFromFetch"

export default function CheckExistingUser(params: {UserName: string, Link?: string}) {
  const requestBody = JSON.stringify(params)
  return ObservableFromFetch<string>("FFOrderUserInvitation/CheckExistingUser", requestBody)
}